module.exports = __webpack_public_path__ + "media/images/front/doctorbook_logo-6de06cff6c867d6931003242b8ce1fe3.jpg";